"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var list_box_1 = __importDefault(require("@paprika/list-box"));
var useI18n_1 = __importDefault(require("@paprika/l10n/lib/useI18n"));
var organizationShape_1 = __importDefault(require("../organizationShape"));
var OrganizationItem_1 = __importDefault(require("./OrganizationItem"));
function OrgSwitcher(_a) {
    var className = _a.className, organizations = _a.organizations, otherText = _a.otherText, renderTrigger = _a.renderTrigger, selectedOrg = _a.selectedOrg;
    var i18n = useI18n_1.default();
    var activeOrganization = organizations.find(function (organization) { return organization.id === selectedOrg.id; });
    var otherL10nText = i18n.t('global_navigation.other');
    var triggerA11yText = i18n.t('global_navigation.app_switcher_a11y', { orgName: activeOrganization.name });
    var sortedOrganizations = react_1.default.useMemo(function () {
        return __spreadArrays(organizations).sort(function (a, b) {
            return (a.customerName && b.customerName && a.customerName.localeCompare(b.customerName)) ||
                a.name.localeCompare(b.name);
        });
    }, [organizations]);
    var formattedOrganizationData = react_1.default.useMemo(function () {
        var orgs = [];
        var others = { heading: otherText || otherL10nText, options: [] };
        sortedOrganizations.forEach(function (organization) {
            var existingCustomerPointer;
            if (organization.customerName) {
                existingCustomerPointer = orgs.find(function (org) { return org.heading === organization.customerName; });
                if (!existingCustomerPointer) {
                    orgs.push({
                        heading: organization.customerName,
                        options: [],
                    });
                    existingCustomerPointer = orgs[orgs.length - 1];
                }
            }
            else {
                existingCustomerPointer = others;
            }
            existingCustomerPointer.options.push({
                id: organization.id,
                isSelected: organization.id === selectedOrg.id,
                orgUrl: organization.launchpad,
                orgName: organization.name,
            });
        });
        return others.options.length ? orgs.concat(others) : orgs;
    }, [sortedOrganizations, selectedOrg.id]);
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(list_box_1.default, null,
            react_1.default.createElement(list_box_1.default.Trigger, null, function (selected, options, _a) {
                var dispatch = _a.dispatch, types = _a.types, refTrigger = _a.refTrigger, isOpen = _a.isOpen;
                return renderTrigger(triggerA11yText, function () { return dispatch({ type: types.togglePopover }); }, isOpen, refTrigger);
            }),
            react_1.default.createElement(list_box_1.default.Popover, { "data-sri-anchor": "org-switcher-popover" }),
            formattedOrganizationData.map(function (org) {
                var html = [];
                html.push(react_1.default.createElement(list_box_1.default.Divider, null, org.heading));
                org.options.forEach(function (option) {
                    html.push(react_1.default.createElement(list_box_1.default.Option, { key: option.id, isSelected: option.isSelected, onClick: function () {
                            window.location = option.orgUrl;
                        } },
                        react_1.default.createElement(OrganizationItem_1.default, { href: option.orgUrl, title: option.orgName })));
                });
                return html;
            }))));
}
OrgSwitcher.propTypes = {
    className: prop_types_1.default.string,
    organizations: prop_types_1.default.arrayOf(prop_types_1.default.shape(organizationShape_1.default)).isRequired,
    otherText: prop_types_1.default.string,
    renderTrigger: prop_types_1.default.func,
    selectedOrg: prop_types_1.default.shape({
        id: prop_types_1.default.number.isRequired,
        title: prop_types_1.default.string.isRequired,
    }).isRequired,
};
OrgSwitcher.defaultProps = {
    className: null,
    otherText: null,
    renderTrigger: null,
};
exports.default = OrgSwitcher;
//# sourceMappingURL=OrgSwitcher.js.map